import * as React from 'react';
import './_CardPreview.scss';
import { ICardPreviewProps } from './types';
import { UserpicStorage } from '../../../../../../base/components/UserpicStorage/UserpicStorage';
import { CARD_PREVIEW_CARD_NAME } from './constants';

export function CardPreview ({
    nextValue,
    prefix,
    userImg,
}: ICardPreviewProps) {
    const imgUrl = require('!file-loader!./card.png').default;

    const className = 'card-number-section-preview';

    return <div className={className}>
        <div className={className + '__card'}>
            <div className={className + '__img'}>
                <img src={imgUrl}/>
            </div>
            <div className={className + '__content'}>
                <div className={className + '__number'}>{prefix}-{nextValue}</div>
                <span className={className + '__name'}>{CARD_PREVIEW_CARD_NAME}</span>
            </div>
            <UserpicStorage src={userImg} size={24} className={className + '__user'}/>
        </div>
    </div>;
};
